import axios from 'src/utils/axios';
import { isHK } from 'src/config/env';
import DomianInfos from 'src/config/domain';

const apis = {
	// 获取登录状态
	getAccountStatus: (data) =>
		axios.post(`/passport${isHK ? '/rest' : ''}/login/check`, data, {
			apiDomain: DomianInfos.loginApi,
		}),
	/** 判断 IP 是否是大陆地区 */
	getIpInMainland: () =>
		axios.get('/kh/rest/ip/in-mainland', {
			apiDomain: DomianInfos.loginApi,
		}),
	/**
	 * 批量获取通用配置链接
	 */
	queryAppConfigUrlsMultiple: (data) => {
		return axios.post(`/dict/rest/app-config/app/urls/multiple-value`, data, {
			form: true,
			apiDomain: DomianInfos.loginApi,
		});
	},
	// 项目主要接口
	/**
	 * 页面详情
	 * @param {*} pageId 页面ID
	 * @returns
	 */
	getPageContent: (data) => {
		return axios.post(`/activity/design/market/marketingPage`, data, {
			form: true,
			apiDomain: DomianInfos.baseApi,
		});
	},
	/**
	 * 模板详情
	 * @param {*} modelIdId 模板ID
	 * @returns
	 */
	getModelContent: (data) => {
		return axios.post(`/activity/design/market/model/marketModelPage`, data, {
			form: true,
			apiDomain: DomianInfos.baseApi,
		});
	},
	/**
	 * 获取活动信息
	 * @param {string}
	 * @returns data
	 */
	getActivityInfo: (params = {}) =>
		axios.get(`/activity/info`, {
			params,
			apiDomain: DomianInfos.baseApi,
		}),
	/**
	 * 主站页面访问控制检查
	 * @param {string}
	 * @returns data
	 */
	getPageAccessControl: (data = {}) => {
		return axios.post(`/activity/design/market/pageAccessControl`, data, {
			form: true,
			apiDomain: DomianInfos.baseApi,
		});
	},
	/**
	 * 国际版获取活动限制
	 * @param {string}
	 * @returns data
	 */
	getActivityLimit: (data = {}) => {
		return axios.post(`/activity/limitCheck`, data, {
			form: true,
			apiDomain: DomianInfos.baseApi,
		});
	},
	/**
	 * 检查卡券是否已经领取(活动页卡券组件)
	 * @param {string}
	 * @returns data
	 */
	checkRewardReceived: (data = {}) => {
		return axios.post(`/activity/design/marketPage/checkRewardReceived`, data, {
			apiDomain: DomianInfos.baseApi,
		});
	},
	/**
	 * 领取卡券(活动页卡券组件)
	 * @param {string}
	 * @returns data
	 */
	receiveReward: (data = {}) => {
		return axios.post(`/activity/design/marketPage/receiveReward`, data, {
			apiDomain: DomianInfos.baseApi,
		});
	},
	/**
	 * 股票行情数据
	 * @param {*} data 股票信息
	 * @returns
	 */
	getStocksBySecurityCodes: (data) => {
		return axios.post(`/hq/querySimpleBySecurityCodes`, data, {
			form: true,
			apiDomain: DomianInfos.hqWebApi,
		});
	},
};

export default apis;
